module.exports = {
      id: "search-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#search",
      toString: function () {
        return this.url;
      }
    }